export const technologies = [
  { group: 'Languages & Frameworks', items: ['Java', 'Spring Boot', 'React', 'Flutter', 'JavaScript', 'HTML5', 'CSS3'] },
  { group: 'Database', items: ['MySQL', 'PostgreSQL', 'MongoDB'] },
  { group: 'Cloud & Infrastructure', items: ['AWS', 'Cloud Infrastructure', 'Linux', 'Docker'] },
  { group: 'Tools', items: ['Git', 'GitHub', 'Jira', 'CI/CD'] },
];
